module.exports = __webpack_public_path__ + "img/IT0000152258579.5656a581.png";